import customizeActive from "../../assets/sidebar/active/customize.svg";
import dishesActive from "../../assets/sidebar/active/dishes.svg";
import classic_inspirationActive from "../../assets/sidebar/active/classic-inspiration.svg";
import taste_harmonyActive from "../../assets/sidebar/active/taste-harmony.svg";
import for_healthActive from "../../assets/sidebar/active/for-health.svg";

import customizeInactive from "../../assets/sidebar/inactive/customize.svg";
import dishesInactive from "../../assets/sidebar/inactive/dishes.svg";
import classic_inspirationInactive from "../../assets/sidebar/inactive/classic-inspiration.svg";
import taste_harmonyInactive from "../../assets/sidebar/inactive/taste-harmony.svg";
import for_healthInactive from "../../assets/sidebar/inactive/for-health.svg";

export const getDefaultCategories = () => {
  return [
    {
      id: 3,
      name: "custom",
      active: customizeActive,
      inactive: customizeInactive,
      mobileName: "custom",
      to: "/",
    },
    {
      id: 1,
      name: "dishSeasoning",
      screen: "Dish Seasoning",
      active: dishesActive,
      inactive: dishesInactive,
      mobileName: "dishSeasoning",
      to: "/categories-condiments/1",
    },
    {
      id: 4,
      name: "classicInspiration",
      screen: "Classic Inspiration",
      active: classic_inspirationActive,
      inactive: classic_inspirationInactive,
      mobileName: "classicInspiration",
      to: "/mixes",
    },
    {
      id: 5,
      name: "tasteHarmony",
      screen: "Taste Harmony",
      active: taste_harmonyActive,
      inactive: taste_harmonyInactive,
      mobileName: "tasteHarmony",
      to: "/taste-harmony",
    },
    {
      id: 2,
      name: "bodyComfort",
      screen: "Body Comfort",
      active: for_healthActive,
      inactive: for_healthInactive,
      mobileName: "bodyComfort",
      to: "/categories-condiments/2",
    },
  ];
};
